// extracted by mini-css-extract-plugin
export var chatHtmlText = "_me-2";
export var chatLink = "_me-0";
export var chatText = "_me-1";